<template>
    <div>
        <div v-if="type === 'icon_only'" class="skeleton">
            <div class="col-2 col-md-2 paddingLeft5" style="width: 33px;">
                <div class="avatar"></div>
                <div class="avatar"></div>
                <div class="avatar"></div>
                <div class="avatar"></div>
                <div class="avatar"></div>
            </div>
        </div>
        <div v-if="type === 'icon_panel'" class="skeleton">
            <div class="col-2 col-md-2 paddingLeft5" style="width: 33px;">
                <div class="avatar"></div>
                <div class="avatar"></div>
                <div class="avatar"></div>
                <div class="avatar"></div>
                <div class="avatar"></div>
            </div>
            <div class="col-10 col-md-10">
                <div class="avatar"></div>
                <div class="panel"></div>
            </div>
        </div>
        <div v-else-if="type === 'avatar_panel'" class="skeleton">
            <div class="avatar"></div>
            <div class="panel"></div>
        </div>
        <div v-else-if="type === 'panel_only'" class="skeleton">
            <div class="panel"></div>
        </div>
        <div v-else-if="type === 'pricing'" class="skeleton">
            <div class="row">
                <div class="col-6 col-md-6" v-for="col in new Array(6)">
                    <div class="marginBottom20">
                        <div class="panel panel--truncated"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="type === 'line_pricing'" class="skeleton">
            <div class="row">
                <div class="col-12 col-md-12" v-for="col in new Array(6)">
                    <div class="line long"></div>
                </div>
            </div>
        </div>
        <div v-else-if="type === 'fees'" class="skeleton">
            <div class="row">
                <div class="col-4 col-md-4" v-for="col in new Array(3)">
                    <div class="marginBottom20">
                        <div class="panel panel--truncated"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="type === 'equipment'" class="skeleton">
            <div class="row">
                <div class="col-md-3 mb-10">
                    <div class="title"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 mb-10" v-for="col in new Array(6)">
                    <div class="marginBottom20">
                        <div class="panel panel--truncated"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="type === 'lines_only'" class="skeleton">
            <div class="title"></div>
            <div class="line"></div>
            <div class="line"></div>
        </div>
        <div v-else-if="type === 'title'" class="skeleton">
            <div class="title"></div>
        </div>
        <div v-else-if="type === 'full_view'" class="skeleton">
            <div class="title"></div>
            <div class="panel"></div>
        </div>
        <div v-else-if="type === 'forms'" class="skeleton">
            <div class="row">
                <div class="title" style="display: block;"></div>
                <div class="title" style="display: block; width: 30%;"></div>
            </div>
            <div class="row">
                <div class="col-md-6 mb-4" v-for="col in new Array(6)">
                    <template v-for="field in new Array(4)">
                        <div class="label"></div>
                        <div class="line"></div>
                    </template>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="panel"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "np-skeleton",
        props: {
            type: {
                type: String
            },
        }
    }
</script>

<style scoped>
    .skeleton {
        width: inherit;
        height: inherit;
    }

    .skeleton .skeleton-panel > .avatar {
        margin: 0;
    }

    .skeleton .avatar {

        /*float: left;*/
        width: 33px;
        height: 33px;
        background-color: #ccc;
        border-radius: 10%;
        margin: 8px;
        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
        background-size: 600px;
        animation: shine-avatar 1.6s infinite linear;
    }

    .skeleton .title {
        /*float: left;*/
        width: 70%;
        height: 30px;
        background-color: #ddd;
        margin: 8px;
        border-radius: 7px;
        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
        background-size: 600px;
        animation: shine-lines 2.6s infinite linear;
    }

    .skeleton .panel {
        /*float: left;*/
        width: 90%;
        min-height: 350px;
        background-color: #ddd;
        margin: 8px;
        border-radius: 3px;
        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
        background-size: 600px;
        animation: shine-lines 2.6s infinite linear;
    }

    .skeleton .panel.panel--truncated {
        min-height: 125px;
        margin: 0px;
        width: 100%;
    }

    .skeleton .line {
        float: left;
        width: 80%;
        height: 16px;
        margin-top: 12px;
        background-color: #ddd;
        border-radius: 7px;
        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
        background-size: 600px;
        animation: shine-lines 2.6s infinite linear;
    }
    .skeleton .line.long {
        width: 100%;
    }

    .skeleton .avatar + .line {
        margin-top: 11px;
        width: 100px;
        background-color: #ddd;
    }

    .skeleton .line ~ .line {
        background-color: #ddd;
    }

    .skeleton .label {
        float: left;
        width: 30%;
        height: 8px;
        margin-top: 12px;
        background-color: #ddd;
        border-radius: 7px;
        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
        background-size: 600px;
        animation: shine-lines 2.6s infinite linear;
    }
    .skeleton .input {
        float: left;
        width: 80%;
        height: 16px;
        margin-top: 12px;
        background-color: #ddd;
        border-radius: 7px;
        background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
        background-size: 600px;
        animation: shine-lines 2.6s infinite linear;
    }


    @keyframes shine-lines {
        0% {
            background-position: -100px;
        }
        40%, 100% {
            background-position: 1400px;
        }
    }

    @-ms-keyframes shine-lines {
        0% {
            background-position: -100px;
        }
        40%, 100% {
            background-position: 1400px;
        }
    }

    @-webkit-keyframes shine-lines {
        0% {
            background-position: -100px;
        }
        40%, 100% {
            background-position: 1400px;
        }
    }

    @keyframes shine-avatar {
        0% {
            background-position: -32px;
        }
        40%, 100% {
            background-position: 208px;
        }
    }

    @-webkit-keyframes shine-avatar {
        0% {
            background-position: -32px;
        }
        40%, 100% {
            background-position: 208px;
        }
    }

    @-ms-keyframes shine-avatar {
        0% {
            background-position: -32px;
        }
        40%, 100% {
            background-position: 208px;
        }
    }

    /* Animations to fade the skeleton in and out */
    @-webkit-keyframes fadein {
        from {
            bottom: 0;
            opacity: 0;
        }
        to {
            bottom: 30px;
            opacity: 1;
        }
    }

    @keyframes fadein {
        from {
            bottom: 0;
            opacity: 0;
        }
        to {
            bottom: 30px;
            opacity: 1;
        }
    }

    @-webkit-keyframes fadeout {
        from {
            bottom: 30px;
            opacity: 1;
        }
        to {
            bottom: 0;
            opacity: 0;
        }
    }

    @keyframes fadeout {
        from {
            bottom: 30px;
            opacity: 1;
        }
        to {
            bottom: 0;
            opacity: 0;
        }
    }

</style>
